import {
  EI9AdminReviewStatus,
  schemes,
  TI9AdminReviewStatus,
} from "@zeal/common";
import { z } from "zod";

export const updateI9AdminReviewRequestSchema = z.discriminatedUnion("status", [
  z.object({
    companyID: schemes.companyID(),
    employeeID: schemes.mongoObjectId(),
    status: z.literal(EI9AdminReviewStatus.CHANGES_REQUESTED),
    requestedChanges: z.string().min(1).max(500),
    isI9SupplementB: z.boolean().optional(),
  }),
  z.object({
    companyID: schemes.companyID(),
    employeeID: schemes.mongoObjectId(),
    status: z.literal(EI9AdminReviewStatus.APPROVED),
    isI9SupplementB: z.boolean().optional(),
  }),
]);

export type TUpdateI9AdminReviewRequest = {
  companyID: string;
  employeeID: string;
  status: TI9AdminReviewStatus;
  requestedChanges?: string;
  ignoreAuthorizedRepresentative?: boolean;
  isI9SupplementB?: boolean;
};
